import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { DataWidgetComponent } from './data-widget.component';
import { MobileAppStiRanking } from '../models/mobileAppStiRanking';

@Component({
  template: ` {{ data?.parentRegion }}`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SellerRegionComponent
  extends DataWidgetComponent
  implements OnInit
{
  @Input()
  data: MobileAppStiRanking;

  ngOnInit() {
    super.ngOnInit();
  }
}
